import React, { useEffect } from "react";
import { gsap } from "gsap";
import { useNavigate } from "react-router-dom";

// Material UI Components
import { Box, Typography } from "@mui/material";

// Material UI Icons
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";

function RegistrationIsOver() {
  const navigate = useNavigate();

  useEffect(() => {
    // Split text into spans for each character
    const textElement = document.querySelector(".t-over");
    const text = textElement.textContent;
    textElement.innerHTML = text
      .split("")
      .map(
        (char, index) =>
          `<span class='char' style='display: inline-block;'>${char}</span>`
      )
      .join("");

    const chars = document.querySelectorAll(".char");

    const tl = gsap.timeline({ repeat: 0 });

    // Rotate each character individually
    tl.to(chars, {
      rotateY: 360,
      duration: 1,
      ease: "circ.inOut",
      stagger: 0.1, // Stagger effect for sequential animation
    }).to(chars, {
      rotateX: 360,
      duration: 1,
      ease: "circ.inOut",
      yoyo: true,
      stagger: 0.1, // Stagger effect for sequential animation
    });
  }, []);

  useEffect(() => {
    // GSAP animation for ".tt-over" flipping and appearing in stages
    const tl = gsap.timeline();

    // Bounce effect happens only once
    tl.fromTo(
      ".tt-over",
      {
        y: -200, // Start above its normal position
      },
      {
        y: 0, // Drop to the normal position
        duration: 2,
        ease: "bounce.out", // Smooth bounce effect
      }
    );

    // Continuous rotation
    tl.to(".tt-over", {
      rotateY: 360, // Full rotation
      duration: 2,
      ease: "power2.inOut", // Smooth easing for rotation
    });

    // Continuous rotation
    tl.to(".tt-over", {
      rotateX: 360, // Full rotation
      duration: 2,
      ease: "power2.inOut", // Smooth easing for rotation
      repeat: -1, // Continuous loop for rotation
      repeatDelay: 1, // Delay between loops
    });
  }, []);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      height="100vh"
      color="white"
    >
      <Box
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Typography
          className="t-over"
          fontWeight="bold"
          sx={{
            fontSize: {
              xs: "1.5rem",
              sm: "3rem",
              md: "5rem",
              lg: "5rem",
              xl: "6rem",
            },
          }}
        >
          Registration&nbsp;is&nbsp;
        </Typography>
        <Typography
          className="tt-over"
          fontWeight="bold"
          sx={{
            color: "#023047",
            bgcolor: "rgba(255, 255, 255, 1)",
            borderRadius: 4,
            px: 2,
            width: "fit-content",
            fontSize: {
              xs: "1.5rem",
              sm: "3rem",
              md: "5rem",
              lg: "5rem",
              xl: "6rem",
            },
          }}
        >
          Over
        </Typography>
      </Box>
      <Typography
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          mt: 2,
        }}
      >
        Registration period is over, try to contact microsoftclub@daiict.ac.in
      </Typography>
      <Typography
        fontWeight="bold"
        sx={{
          my: 2,
          bgcolor: "rgba(255, 255, 255, 0.1)",
          p: 1,
          borderRadius: 2,
          width: "50px",
          height: "50px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        OR
      </Typography>
      <button
        onClick={() => navigate("/contact-us")}
        style={{
          borderColor: "white",
          backgroundColor: "white",
          color: "#023047",
          borderRadius: 8,
          fontSize: "1rem",
        }}
        onMouseEnter={(e) => (
          (e.currentTarget.style.color = "white"),
          (e.currentTarget.style.backgroundColor = "#023047")
        )}
        onMouseLeave={(e) => (
          (e.currentTarget.style.color = "#023047"),
          (e.currentTarget.style.backgroundColor = "white")
        )}
      >
        <Typography fontWeight="bold" sx={{ mx: 2 }}>
          Fill Out the Contact Us Form
        </Typography>
        <ArrowOutwardRoundedIcon />
      </button>
    </Box>
  );
}

export default RegistrationIsOver;
